export default "/images/vendor/flag-icon-css/flags/1x1/pm.svg?4917cb53c94d712037f8f7b16818530a";